import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=356f3704&scoped=true"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"
import style0 from "./Forget.vue?vue&type=style&index=0&id=356f3704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f3704",
  null
  
)

export default component.exports